import { Box, Button, HStack, Text, ToastId, useToast } from '@chakra-ui/react';
import React from 'react';

export function MaxRetriesDialog({ isOpen, onReconnect }: { isOpen: boolean; onReconnect: () => void }) {
  const toast = useToast();
  const toastIdRef = React.useRef<ToastId | null>(null);

  React.useEffect(() => {
    if (toastIdRef.current && toast.isActive(toastIdRef.current)) {
      return;
    }

    if (!isOpen) {
      return;
    }

    toastIdRef.current = toast({
      position: 'bottom', // ⬅️ bottom of the screen
      duration: null, // stay until dismissed
      isClosable: true,
      render: ({ onClose }) => (
        <Box borderWidth='1px' rounded='xl' boxShadow='lg' p={3} maxW='m'>
          <HStack justify='space-between' align='center' spacing={5}>
            <Text>
              Could not connect to production service.
              <br />
              Please try again later.
            </Text>
            <HStack>
              <Button size='sm' colorScheme='blue' onClick={onReconnect}>
                Retry
              </Button>
            </HStack>
          </HStack>
        </Box>
      ),
    });

    return () => {
      if (toastIdRef.current) {
        toast.close(toastIdRef.current);
        toastIdRef.current = null;
      }
    };
  }, [toast, isOpen]);

  return <></>;
}
